import { AgeRangeService, AgeRange } from '@openeducation/oe-it-services';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';
import { QueryKeys } from '../interfaces/query-keys';

export function useAgeRange() {
  const { environment } = useEnvironmentContext();
  const { t } = useTranslation();

  const { data: ageRangeData, isLoading: isLoadingAgeRangeData } = useQuery<
    AgeRange[]
  >([QueryKeys.AgeRange], () => AgeRangeService.getAgeRange(environment));

  const translatedAgeRangeData = useMemo<AgeRange[]>(() => {
    return (
      ageRangeData?.map(({ ageRange, ...rest }) => {
        const textWithoutYears = ageRange.slice(0, ageRange.search('years'));
        const translatedAgeRange = textWithoutYears + t('years');
        return {
          ...rest,
          ageRange: translatedAgeRange,
        };
      }) || []
    );
  }, [ageRangeData, t]);

  return { ageRangeData, isLoadingAgeRangeData, translatedAgeRangeData };
}
